<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document" style="max-width:960px;">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Üzlet nyitvatartása</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<h5 class="p-3 m-0">Normál nyitvatartás</h5>
			<div class="row g-0">
				<div class="col-auto" style="width:1122px;">
					<div class="p-3">
						<%- include('/ui/form_array', {
							prefix: 'opening',
							fixed: true,
							data: opening_hours,
							model: Anvil.models.c_order.OpeningHours_Regular,
							name: 'regular_days',
							placeholder: '-- Még nincs hozzáadva sor --',
							fields: [
								{
									type: 'group',
									no_label: true,
									fields: [
										{
											type: 'label',
											field: 'day',
											name: 'day',
											format: (v) => {
												return {
													monday: 'Hétfő',
													tuesday: 'Kedd',
													wednesday: 'Szerda',
													thursday: 'Csütörtök',
													friday: 'Péntek',
													saturday: 'Szombat',
													sunday: 'Vasárnap'
												}[v]
											},
											attributes: {
												style: 'width:350px;'
											},
											width: 'auto'
										},
										{
											type: 'text',
											variant: 'time',
											name: 'open',
											title: 'Nyitás',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'text',
											variant: 'time',
											name: 'close',
											title: 'Zárás',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'checkbox',
											name: 'closed',
											title: 'Zárva',
											description: 'Zárva',
											update (value, name, data, params) {
												const offset = Anvil.page.modal.opening_hours.regular_days.indexOf(data)
												Anvil.page.modal.opening_hours.regular_days[offset].open = null
												Anvil.page.modal.opening_hours.regular_days[offset].close = null
												$(`#opening_regular_days_${offset}_open`).get(0).disabled = (value == 1)
												$(`#opening_regular_days_${offset}_close`).get(0).disabled = (value == 1)

												Anvil.page.modal.opening_hours.regular_days[offset].web_closed = 1
												$(`#opening_regular_days_${offset}_web_closed`).get(0).disabled = (value == 1)
											}
										},
										{
											type: 'html',
											content: '<div class="col-auto" style="width:20px;"></div>'
										},
										{
											type: 'text',
											variant: 'time',
											name: 'web_open',
											title: 'Nyitás (web)',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'text',
											variant: 'time',
											name: 'web_close',
											title: 'Zárás (web)',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'checkbox',
											name: 'web_closed',
											title: 'Nincs',
											description: 'Nincs',
											update (value, name, data, params) {
												const offset = Anvil.page.modal.opening_hours.regular_days.indexOf(data)
												Anvil.page.modal.opening_hours.regular_days[offset].web_open = null
												Anvil.page.modal.opening_hours.regular_days[offset].web_close = null
												$(`#opening_regular_days_${offset}_web_open`).get(0).disabled = (value == 1)
												$(`#opening_regular_days_${offset}_web_close`).get(0).disabled = (value == 1)
											}
										}
									]
								}
							]
						}) %>
					</div>
				</div>
			</div>
			<h5 class="p-3 m-0">Rendkívüli nyitvatartás</h5>
			<div class="row g-0">
				<div class="col-auto" style="width:1182px;">
					<div class="p-3">
						<%- include('/ui/form_array', {
							prefix: 'opening',
							data: opening_hours,
							model: Anvil.models.c_order.OpeningHours_Irregular,
							name: 'irregular_days',
							placeholder: '-- Még nincs hozzáadva sor --',
							fields: [
								{
									type: 'group',
									no_label: true,
									title: '',
									fields: [
										{
											type: 'text',
											variant: 'date',
											name: 'start_d',
											title: 'Időszak kezdete',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'text',
											variant: 'date',
											name: 'end_d',
											title: 'Időszak vége',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'text',
											variant: 'time',
											name: 'open',
											title: 'Nyitás',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'text',
											variant: 'time',
											name: 'close',
											title: 'Zárás',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'checkbox',
											name: 'closed',
											title: 'Zárva',
											description: 'Zárva',
											update (value, name, data, params) {
												const offset = Anvil.page.modal.opening_hours.irregular_days.indexOf(data)
												Anvil.page.modal.opening_hours.irregular_days[offset].open = null
												Anvil.page.modal.opening_hours.irregular_days[offset].close = null
												$(`#opening_irregular_days_${offset}_open`).get(0).disabled = (value == 1)
												$(`#opening_irregular_days_${offset}_close`).get(0).disabled = (value == 1)

												Anvil.page.modal.opening_hours.irregular_days[offset].web_closed = 1
												$(`#opening_irregular_days_${offset}_web_closed`).get(0).disabled = (value == 1)
											}
										},
										{
											type: 'html',
											content: '<div class="col-auto" style="width:20px;"></div>'
										},
										{
											type: 'text',
											variant: 'time',
											name: 'web_open',
											title: 'Nyitás (web)',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'text',
											variant: 'time',
											name: 'web_close',
											title: 'Zárás (web)',
											attributes: {
												style: 'font-family:monospace;'
											}
										},
										{
											type: 'checkbox',
											name: 'web_closed',
											title: 'Nincs',
											description: 'Nincs',
											update (value, name, data, params) {
												const offset = Anvil.page.modal.opening_hours.irregular_days.indexOf(data)
												Anvil.page.modal.opening_hours.irregular_days[offset].web_open = null
												Anvil.page.modal.opening_hours.irregular_days[offset].web_close = null
												$(`#opening_irregular_days_${offset}_web_open`).get(0).disabled = (value == 1)
												$(`#opening_irregular_days_${offset}_web_close`).get(0).disabled = (value == 1)
											}
										},
										{
											type: 'html',
											content: '<div class="col-auto" style="width:20px;"></div>'
										},
										{
											type: 'html',
											content: `<div class="col-auto text-end" style="width:40px;"><button type="button" class="remove-btn btn btn-danger text-light" style="padding-top:6px; padding-bottom:5px;"><i class="fa fa-trash"></i></button></div>`
										}
									]
								}
							],
							update: function () {
								for (const irregular_day of Anvil.page.modal.opening_hours.irregular_days) {
									const offset = Anvil.page.modal.opening_hours.irregular_days.indexOf(irregular_day)
									if (irregular_day.closed == 1) {
										$(`#opening_irregular_days_${offset}_open`).get(0).disabled = true
										$(`#opening_irregular_days_${offset}_close`).get(0).disabled = true
										$(`#opening_irregular_days_${offset}_web_closed`).get(0).disabled = true
									}
									if (irregular_day.web_closed == 1) {
										$(`#opening_irregular_days_${offset}_web_open`).get(0).disabled = true
										$(`#opening_irregular_days_${offset}_web_close`).get(0).disabled = true
									}
								}
							}
						}) %>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer text-end">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	init () {
		for (const regular_day of Anvil.page.modal.opening_hours.regular_days) {
			const offset = Anvil.page.modal.opening_hours.regular_days.indexOf(regular_day)
			if (regular_day.closed == 1) {
				$(`#opening_regular_days_${offset}_open`).get(0).disabled = true
				$(`#opening_regular_days_${offset}_close`).get(0).disabled = true
				$(`#opening_regular_days_${offset}_web_closed`).get(0).disabled = true
			}
			if (regular_day.web_closed == 1) {
				$(`#opening_regular_days_${offset}_web_open`).get(0).disabled = true
				$(`#opening_regular_days_${offset}_web_close`).get(0).disabled = true
			}
		}

		for (const irregular_day of Anvil.page.modal.opening_hours.irregular_days) {
			const offset = Anvil.page.modal.opening_hours.irregular_days.indexOf(irregular_day)
			if (irregular_day.closed == 1) {
				$(`#opening_irregular_days_${offset}_open`).get(0).disabled = true
				$(`#opening_irregular_days_${offset}_close`).get(0).disabled = true
				$(`#opening_irregular_days_${offset}_web_closed`).get(0).disabled = true
			}
			if (irregular_day.web_closed == 1) {
				$(`#opening_irregular_days_${offset}_web_open`).get(0).disabled = true
				$(`#opening_irregular_days_${offset}_web_close`).get(0).disabled = true
			}
		}
	},

	async save () {
		const res = await Anvil.exec('c_order/storage/action_save_opening_hours', Anvil.page.modal.storage, Anvil.page.modal.opening_hours)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
